<template>
    <div class="entity-confirm-action">
        <div class="entity-confirm-action__title">
            <slot></slot>
        </div>

        <div class="entity">
            <div class="entity__title">{{ reportPeriod }}</div>

            <div class="entity__list">
                <div class="entity__list-item">
                    <div class="entity__list-label">Дилер:</div>
                    <div class="entity__list-value">{{ report.dealer.name }}</div>
                </div>

                <div class="entity__list-item">
                    <div class="entity__list-label">Код дилера:</div>
                    <div class="entity__list-value">{{ report.dealer.sap_code }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue';
    import { CarPlacementSaleReport } from '@/types/report.type.ts';

    const { report } = defineProps<{
        report: CarPlacementSaleReport,
    }>();

    const reportPeriod = computed<string>(() => {
        return `${monthNames[report.month - 1]} ${report.year}`;
    });

    const monthNames = [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь',
    ];
</script>
